import mailvistaSymbol from "@/assets/images/mailvista-symbol.png";

interface MailvistaLogoProps {
    className?: string;
}

const MailvistaLogo = ({ className }: MailvistaLogoProps) => (
    <img
        alt="Mailvista Logo"
        className={`mb-4 h-9 w-9 ${className}`}
        src={mailvistaSymbol}
    />
);

export default MailvistaLogo;
